import { TEmAssignmentResponse } from 'redux/reducers/settings/types';

export type TEditableSetting = 'timezone' | 'productLanguage' | 'iossSaleOverThreshold';

export type TGeneralSettingRow = {
	name: keyof TEmAssignmentResponse;
	title: string;
	editable?: TEditableSetting;
	secret?: boolean;
};

export const GENERAL_SETTINGS_ROWS: TGeneralSettingRow[] = [
	{ name: 'fullName', title: 'Name' },
	{ name: 'tinNumber', title: 'Tax/Business Identification Number ' },
	{ name: 'timezone', title: 'Timezone', editable: 'timezone' },
	{ name: 'easFeeIncludedInLandedCost', title: 'EAS Fee calculation method' },
	{ name: 'clientId', title: 'API Key' },
	{ name: 'clientSecret', title: 'API Secret', secret: true },
	// { name: 'productLanguage', title: 'Product Description Language', editable: 'productLanguage' },
	{
		name: 'iossSaleOverThreshold',
		title: 'Import EU sales over 150 EUR (threshold) per order / Import NON EU sales over 150 EUR',
		editable: 'iossSaleOverThreshold',
	},
];

export const EDIT_SETTING_TEXT: Record<TEditableSetting, string> = {
	timezone: 'Do you want change timezone for merchant',
	productLanguage: 'Do you want to change Product Description Language for merchant',
	iossSaleOverThreshold:
		'Do you want to change IOSS sales over 150 EUR (threshold) per order for merchant',
};

export const EAS_FEE_CALCULATION_OPTIONS: string[][] = [
	['true', 'Included in landed cost'],
	['false', 'Not included in landed cost'],
];

export const IOSS_SALE_OVER_THRESHOLD_OPTIONS: string[][] = [
	['TOTALLY_RESTRICT', 'Totally Restrict'],
	['ALLOWED_WITH_CONFIRM', 'Allowed with Confirm'],
	['ALLOWED', 'Allowed'],
];

const LANGUAGE_CODES = [
	'bg',
	'cs',
	'da',
	'de',
	'el',
	'en',
	'es',
	'et',
	'fi',
	'fr',
	'ga',
	'hr',
	'hu',
	'it',
	'lt',
	'lv',
	'mt',
	'nl',
	'pl',
	'pt',
	'ro',
	'sk',
	'sl',
	'sv',
];

const languageNames = new Intl.DisplayNames(['en'], { type: 'language' });

export const PRODUCT_LANGUAGE_OPTIONS: string[][] = LANGUAGE_CODES.map((code) => [
	code,
	languageNames.of(code) ?? code,
]).sort((a, b) => a[1].localeCompare(b[1]));
